import { RECEIVE_ACCOUNTANT, REQUEST_ACCOUNTANT } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_ACCOUNTANT:
            return { ...state, shouldFetch: false }

        case RECEIVE_ACCOUNTANT:
            return { ...state, ...data }

        default:
            return state
    }
}
